<div class="header">
  <h3>รายได้รวมและหนี้ค้างชำระ</h3>
</div>

<div class="box-parent">
  <div class="row">
    <div class="col-12">
      <iframe title="chod-dashboard"
              width="100%"
              style="height: calc(100vh - 13.5rem);"
              [src]="urlSafe"
              frameborder="0">
      </iframe>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// /opt/app/src/app/features/power-bi-dashboard/overdue-debt/overdue-debt.component.html